<template>
    <AuthenticatedLayout>
      <div class="users">
        <!-- Cabeçalho -->
        <header class="users-header">
          <h2>Seu perfil</h2>          
            <!-- Botão para alternar entre tabela e kanban -->
            <el-button @click="handleOpenDrawer()" type="info">
                Atualizar seus dados
            </el-button>
        </header>
  
        <el-descriptions            
            direction="vertical"
            border
            style="margin-top: 20px"
        >
            <el-descriptions-item
                :rowspan="2"
                :width="140"
                label="Foto"
                align="center"
            >
            <el-image
                style="width: 100px; height: 100px"
                :src="user.avatar"
            />
            </el-descriptions-item>
            <el-descriptions-item label="Nome">{{ user.name }}</el-descriptions-item>
            <el-descriptions-item label="E-mail">{{ user.email }}</el-descriptions-item>
            <el-descriptions-item label="Qtde. Tarefas">{{ user.tasks }}</el-descriptions-item>
            <el-descriptions-item label="Status">
                <el-tag size="small">{{ user.status }}</el-tag>
            </el-descriptions-item>            
        </el-descriptions>        

        <el-drawer v-model="drawer">
            <template #header>
              <h4>Atualize seus dados abaixos</h4>
            </template>
            <template #default>
                <el-form :model="userForm">
                    <el-form-item label="Sua Foto">
                        <el-upload 
                            action="#" 
                            list-type="picture-card" 
                            :auto-upload="false"
                            :limit="1"
                        >
                        <el-icon><Plus /></el-icon>
                    
                        <template #file="{ file }">
                          <div>
                            <img class="el-upload-list__item-thumbnail" :src="file.url" alt="" />
                            <span class="el-upload-list__item-actions">
                              <span
                                class="el-upload-list__item-preview"
                                @click="handlePictureCardPreview(file)"
                              >
                                <el-icon><zoom-in /></el-icon>
                              </span>
                              <span
                                v-if="!disabled"
                                class="el-upload-list__item-delete"
                                @click="handleDownload(file)"
                              >
                                <el-icon><Download /></el-icon>
                              </span>
                              <span
                                v-if="!disabled"
                                class="el-upload-list__item-delete"
                                @click="handleRemove(file)"
                              >
                                <el-icon><Delete /></el-icon>
                              </span>
                            </span>
                          </div>
                        </template>
                        </el-upload>
                    </el-form-item>                    
                    <el-form-item label="ID" v-if="userForm.id">
                        <el-input v-model="userForm.id" disabled />
                    </el-form-item>
                    <el-form-item label="Nome">
                        <el-input v-model="userForm.name" />
                    </el-form-item>
                    <el-form-item label="E-mail">
                        <el-input v-model="userForm.email" />
                    </el-form-item>
                    <el-form-item label="Senha">
                        <el-input type="password" v-model="userForm.password" show-password />
                    </el-form-item>
                    <el-form-item label="Confirme sua senha">
                        <el-input type="password" v-model="userForm.passwordConfirm" show-password />
                    </el-form-item>
    
                    <el-form-item label="Status">
                        <el-select v-model="userForm.status" placeholder="Selecione o Status">
                            <el-option label="Ativo" value="Ativo" />
                            <el-option label="Inativo" value="Inativo" />
                        </el-select>
                    </el-form-item>
        
                </el-form>
            </template>
            <template #footer>
              <div style="flex: auto">
                <el-button @click="closeDrawer()">Fechar</el-button>
                <el-button type="primary" @click="saveUser()">Salvar</el-button>
              </div>
            </template>
          </el-drawer>
      </div>
    </AuthenticatedLayout>
  </template>
  
<script>
import AuthenticatedLayout from "@/layouts/AuthenticatedLayout.vue";  

export default {
name: "ProfileView",
components: {
    AuthenticatedLayout    
},
data() {
    return {
        urlApi: process.env.VUE_APP_API_URL,
        user: {},
        userForm: {
            id: null,
            name: '',
            email: '',
            password: '',
            status: 'ativo'            
        },
        loading: false,
        drawer: false,
        dialogImageUrl: '',
        dialogVisible: false,
        disabled: false
    };
},    
methods: {
    fetchUser() {
        this.user = {
            id: 1,
            avatar: "https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png",
            name: "Diego Sampaio",
            email: "diegosampaio.dev@gmail.com",
            status: "Ativo",
            tasks: 15
        }
    },
    handleOpenDrawer() {            
        this.userForm = {                
            name: this.user.name,                
            email: this.user.email,                                
            status: this.user.status
        }

        this.drawer = true;
    },

    async saveUser() {
        this.loading = true;
        const method = this.userForm.id ? "PUT" : "POST";
        const url = `${this.urlApi}/users/${(this.userForm.id ?? "")}`;

        try {
            await fetch(url, {
                method,
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(this.userForm)
            });
            this.user = {... this.userForm}
            this.$message.success("Usuário atualizado com sucesso!");
            this.drawer = false;            
            this.fetchUsers();
        } catch (error) {
            this.$message.error("Erro ao atualizar usuário!");
        } finally {
            this.loading = false;
        }
    },

    closeDrawer() {
        this.drawer = false;            
    },

    handleRemove(file) {
      console.log(file);
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url || '';
      this.dialogVisible = true;
    },
    handleDownload(file) {
      console.log(file);
    },
},
mounted() {
    this.fetchUser();  
},
};
</script>

<style scoped>
.users-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
}
.users-header h2 {
    font-size: 24px;
    margin: 0;
}
.notification-icon {
    cursor: pointer;
}
</style>
